import { LitElement, html, TemplateResult } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { styles } from '../view/styles';

@customElement('gz-widget-product-item')
export class GzWidgetProductItemWebComponent extends LitElement {
  private readonly DEFAULT_BORDER_COLOR = 'var(--chart-101-pressed-dividers)';

  @property({ type: String, attribute: true, reflect: true })
  name: string;

  @property({ type: String, attribute: true, reflect: true })
  description?;

  @property({ type: String, attribute: true, reflect: true })
  iconClass?: string;

  @property({ type: String, attribute: true, reflect: true })
  borderColor? = this.DEFAULT_BORDER_COLOR;

  static get styles() {
    return styles;
  }

  render(): TemplateResult {
    return html`
      <div class="product-wrapper" style="border: 1px solid ${this.getBorderColor()};">
        <gz-tooltip tooltipText="${this.name}" isEllipsis> ${this.name} </gz-tooltip>
        ${this.renderProductDescription()}
      </div>
    `;
  }

  private renderProductDescription(): TemplateResult | undefined {
    return this.description
      ? html` <div class="d-flex">
          <gz-text fontSize="12" lineHeight="1.2" class="description-txt">${this.description}</gz-text>
          ${this.renderIcon()}
        </div>`
      : undefined;
  }

  private renderIcon(): TemplateResult | undefined {
    return this.iconClass
      ? html`<gz-icon name="${this.iconClass}" size="16" color="${this.borderColor}" />`
      : undefined;
  }

  private getBorderColor(): string {
    return this.borderColor ? this.borderColor : this.DEFAULT_BORDER_COLOR;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'gz-widget-product-item': GzWidgetProductItemWebComponent;
  }
}
